import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {
    ProfileAdditionalColumnField,
    ProfileAdditionalColumnType,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/storefrontCustomerProfilesWorkspaceCapability/domain/StorefrontCustomerProfiles";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type ProfileAdditionalColumnConfiguration = {
    required: boolean;
    unique?: boolean;
};

type ProfileAdditionalColumnBase = {
    configuration: ProfileAdditionalColumnConfiguration;
    displayName: string;
    id: Uuid;
};

export type ProfileAdditionalColumn =
    | (ProfileAdditionalColumnBase & {
        type: ProfileAdditionalColumnType.email;
    })
    | (ProfileAdditionalColumnBase & {
        type: ProfileAdditionalColumnType.indianPhoneNumber;
    })
    | (ProfileAdditionalColumnBase & {
        field: ProfileAdditionalColumnField;
        type: ProfileAdditionalColumnType.text;
    });

const profileAdditionalColumnConfigurationValidator: zod.ZodType<ProfileAdditionalColumnConfiguration> = zod.strictObject({
    required: zod.boolean(),
    unique: zod.boolean().optional(),
});

const profileAdditionalColumnBaseValidator = zod.strictObject({
    configuration: profileAdditionalColumnConfigurationValidator,
    displayName: zod.string(),
    id: uuidZodValidator,
});

const profileAdditionalColumnValidator: zod.ZodType<ProfileAdditionalColumn> = zod.union([
    profileAdditionalColumnBaseValidator.extend({
        type: zod.literal(ProfileAdditionalColumnType.email),
    }),
    profileAdditionalColumnBaseValidator.extend({
        type: zod.literal(ProfileAdditionalColumnType.indianPhoneNumber),
    }),
    profileAdditionalColumnBaseValidator.extend({
        field: zod.enum(ProfileAdditionalColumnField),
        type: zod.literal(ProfileAdditionalColumnType.text),
    }),
]);

export type StorefrontCustomerProfilesWorkspaceCapabilityConfiguration = {
    additionalColumns: Array<ProfileAdditionalColumn>;
};

export const storefrontCustomerProfilesWorkspaceCapabilityConfigurationValidator: zod.ZodType<StorefrontCustomerProfilesWorkspaceCapabilityConfiguration> = zod.strictObject({
    additionalColumns: profileAdditionalColumnValidator.array(),
});
